import { v } from '../validation'

// exported here for reuse in multiple places, and to enable changing the validation library in the future
export const newClientSchema = v.object({
  emailAddress: v.string().email().label('Email'),
  highRisk: v.boolean().label('High risk'),
  billingAddressee: v.string().max(100).label('Billing addressee'),
  billingHouse: v.string().max(50).label('Billing house'),
  billingArea: v.string().max(50).label('Billing area'),
  billingCounty: v.string().max(50).label('Billing county'),
  billingPostalTown: v.string().max(50).label('Billing town'),
  billingPostcode: v.string().max(10).label('Billing postcode'),
  namedClients: v
    .array()
    .min(1)
    .of(
      v.object({
        clientType: v.string().oneOf(['I', 'C']).label('Client type'),
        title: v.string().max(10).label('Title'),
        forename: v.string().max(30).label('Forename'),
        initials: v.string().max(5).label('Initials'),
        surname: v.string().max(255).label('Surname/company name').required(),
        emailAddress: v.string().max(255).email().label('Email address'),
        house: v.string().max(50).label('House'),
        area: v.string().max(50).label('Area'),
        postalTown: v.string().max(50).label('Postal town'),
        county: v.string().max(50).label('County'),
        postcode: v.string().max(10).label('Postcode')
      })
    )
})

const digitsOrEmptyStringRegex = /^\d*$/

export const accountControlSchema = v.object({
  wipLimit: v.string().matches(digitsOrEmptyStringRegex, 'Must be a number').label('WIP limit'),
  debtorLimit: v.string().matches(digitsOrEmptyStringRegex, 'Must be a number').label('Debtor limit'),
  disbursementsLimit: v.string().matches(digitsOrEmptyStringRegex, 'Must be a number').label('Disbursements limit')
})

export const phoneSchema = v.object({
  clientPhones: v.array().of(
    v.object({
      phoneNumber: v
        .string()
        .matches(/^[0-9+() ]+$/, 'Can only contain numbers, + or ()')
        .label('Phone number')
        .required(),
      description: v.string().min(0).max(50).label('Description'),
      phoneType: v.object().label('Phone type').required()
    })
  )
})
